export function loadScript(scriptUrl: string, id: string): Promise<any> {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.id = id;
    script.setAttribute('type', 'text/javascript');

    document.body.appendChild(script);

    return new Promise((res, rej) => {
        script.onload = function () {
            res(null);
        };
        script.onerror = function () {
            rej();
        };
    });
}
